import api from './api';

export const agendaService = {
    getList: async (params = {}) => {
        try {
            const response = await api.get('/agenda-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getDetail: async (id) => {
        try {
            const response = await api.get(`/agenda-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    create: async (formData) => {
        try {
            const response = await api.post('/agenda-admin', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    update: async (id, formData) => {
        try {
            const response = await api.post(`/agenda-admin/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/agenda-admin/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    getStatistics: async () => {
        try {
            const response = await api.get('/agenda-statistics');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil statistik' };
        }
    },
};

export default agendaService;